module.exports = __webpack_public_path__ + "static/media/palm.f7d8e507.svg";